
export default {
  props: {
    player: {
      type: Object,
      required: true,
    },
  },
  computed: {
    goals () {
      return this.player.goal;
    },
    assists () {
      return this.player.assist;
    },
    yellowCards () {
      return this.player.yellowCard;
    },
    redCards () {
      return this.player.redCard;
    },
    subbedOff () {
      return this.player.sub;
    },
    ownGoals () {
      return this.player.ownGoal;
    },
    captain () {
      return this.player.captain;
    },
  },
};
